import { Typography } from 'antd';
import { ReactComponent as MailIcon } from '../../../../Assets/sib/mail.svg';
import { EVENTCODES, pushEventToParent } from '../../../../Utils/eventUtils';
import styles from './index.module.css';

const SIBFooter: React.FC = () => {

  return (
    <div className={styles.helpSection}>
      <Typography.Text className={styles.helpTitle}>
        Still Need Help?
      </Typography.Text>
      <Typography.Text className={styles.helpSubtitle}>
        Contact us at customercare@sib.bank.in
      </Typography.Text>
      <div className={styles.helpIconWrapper} >
        <MailIcon className={styles.helpMailIcon} />
      </div>
    </div>
  );
};

export default SIBFooter;
